import React, { forwardRef } from "react";
import { MDBDataTableV5 } from "mdbreact";
import moment from "moment";

const DataTableAdmins = forwardRef((props, ref) => {

	let data = props.data;
	let finalData = [];

	if (data) {
		for (var index = 0; index < data.length; index++) {
			let rowItem = {};
			rowItem["id"] = index+1;
			rowItem["fullName"] = data[index].first_name +' '+ data[index].last_name;
			rowItem["first_name"] = data[index].first_name;
			rowItem["last_name"] = data[index].last_name;
			rowItem["email"] = data[index].email;
			rowItem["contact_no"] = data[index].contact_no ? data[index].contact_no : 'N/A';
			rowItem["createdAt"] = moment(data[index].createdAt).format('DD/MM/YYYY');
			rowItem["userId"] = data[index].id;
			rowItem["mode"] = "edit";
			rowItem["status"] = data[index]?.is_blocked;
			rowItem["statusButton"] = <button className={`${data[index]?.is_blocked ? 'btn btn-danger' : 'btn btn-primary'}`} onClick={() => props.changeStatus(rowItem)}> {data[index]?.is_blocked ? <i className='fa fa-lock'></i> : <i className='fa fa-unlock'></i> }</button>;
			rowItem["editButton"] = <button className="btn custom-btn-outline-info" onClick={() => props.openModal(rowItem)}><i className="fa fa-edit"></i></button>;
		    
		finalData.push(rowItem);
		}
		console.log("final data", finalData);
	}
	
//const [datatable, setDatatable] = React.useState({
const datatable = {  
  columns: [
      {
        label: 'Name',
        field: 'fullName',
        sort: 'asc',
        width: 150
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc',
        width: 270
      },
      {
        label: 'Created At',
        field: 'createdAt',
        sort: 'asc',
        width: 200
      },
      {
        label: 'Contact No',
        field: 'contact_no',
        sort: 'asc',
        width: 150
      },
	  {
        label: 'Status',
        field: 'statusButton',
        width: 150,
		sort: 'disabled'
      }, 
	  {
        label: '',
        field: 'editButton',
        width: 150,
		sort: 'disabled'
      } 
    ],
    rows: finalData 
	};
  return (
    <MDBDataTableV5 
		hover
		id="mdbDtTable"
		entries={20}
        data={datatable}
   		striped
		bordered
		small
		searchTop
		sortable={false}
		searchBottom={false}

    />
	
	
	

	
  );
});

export default DataTableAdmins;